<template>
  <modal :state="state" :index="index" @toggle-modal="emitHideModal" :size="'md'">
    <div slot="body" class="fds">
      <h3 class="modal-title h3">{{details.confirmationHeader}}</h3>
      <div class="spinner" v-if="addSpinner">
        <img src="@assets/images/_icon-spinner.svg" alt="Loading Spinner">
      </div>
      <p class="p" v-if="details.confirmationMessage">{{details.confirmationMessage}}</p>
      <p class="p" v-else-if="details.htmlSafeConfirmationMessage" v-html="details.htmlSafeConfirmationMessage"></p>
      <div class="row pt-2 modal-btn-group">
        <div class="col">
          <div class="cta">
            <button type="button" v-if="details.showCancel" @click="cancelEvent" :class="buttonClass('cancel')" data-action="cancel">{{details.cancelText}}</button>
            <button type="button" v-if="details.showAffirm" @click="affirmEvent" :class="buttonClass('affirm')" data-action="affirm">{{details.affirmText}}</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";
  import VersionTypeMixin from "../../mixins/versionTypeMixin";
  import { IConfirmModalConfig } from '../../interfaces/modalInterfaces'
  import {Hash} from "~/interfaces/hashInterfaces";


  export default Vue.extend({
    mixins: [
      VersionTypeMixin
    ],
    props: {
      state: Object,
      affirm: Boolean,
      overrideConfig: {
        type: Object as () => Partial<IConfirmModalConfig>,
        default: () => {
          return {};
        }
      },
      config: {
        type: Object as () => Partial<IConfirmModalConfig>,
        default: null,
      },
      addSpinner: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      details(){
        if (this.config) {
          return this.config;
        } else return Object.assign(this.defaultConfig, this.overrideConfig)
      },
      affirmData(): Hash {
        return this.details.affirmData || null;
      },
      cancelData(): Hash {
        return this.details.cancelData || null;
      }
    },
    methods: {
      buttonClass(type){
       let baseClass = {btn: true, block: true};
       if (type === "affirm") {
         baseClass[this.details.affirmButtonClass] = true;
       } else if (type === "cancel") {
         baseClass[this.details.cancelButtonClass] = true;
       }
       return baseClass;
      },
      affirmEvent(event) {
        this.$emit('affirm-cta', this.affirmData)
        this.emitHideModal(event);
      },
      cancelEvent(event) {
        this.$emit('cancel-cta', this.cancelData)
        this.emitHideModal(event);
      }
    },
    data: function(): {defaultConfig: IConfirmModalConfig} {
      return {
        defaultConfig: {
          cancelButtonClass: "red outline",
          affirmButtonClass: "green",
          confirmationHeader: "Are you sure?",
          confirmationMessage: null,
          showAffirm: true,
          affirmText: "Continue",
          showCancel: true,
          cancelText: "Cancel",
        }
      };

    }
  });
</script>